module.exports = __webpack_public_path__ + "img/bands-white.677bd436.png";